import { render, staticRenderFns } from "./CoamoEmNumeros.vue?vue&type=template&id=7a036e14&scoped=true&lang=pug"
import script from "./CoamoEmNumeros.vue?vue&type=script&lang=js"
export * from "./CoamoEmNumeros.vue?vue&type=script&lang=js"
import style0 from "./CoamoEmNumeros.styl?vue&type=style&index=0&id=7a036e14&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a036e14",
  null
  
)

export default component.exports